import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';
import createPersistedState from 'vuex-persistedstate';
import jwt_decode from 'jwt-decode';


Vue.use(Vuex);

export default new Vuex.Store({
    // State = the data
    state: {
        //_apiURL: 'http://127.0.0.1:8000',
        _apiURL: 'https://ainakcloud.herokuapp.com',
        _token: '',
        _user_authenticated: false,
        _userID: '',
        _username: '',
        loadedModels: [],
        userProfile: [],
        userParentProfile:[],
        userChildrenProfiles:[],
        licensesLeft:0,
        modelInfo: [],
        modelMetaData: [],
        openUploadPage: 0,
        uploadProgress:[],
        uploadStatus:[],

        // For on boarding purpose
        stopTutorial: false,
        isNewUser: true,

        PaymentPortal_linked: false,
        PaymentPortal_CustomerObject: [],
        PaymentPortal_SubscriptionObject: [],
        PaymentPortal_PlanObject: []
        

    },
    // Mutations = Editing the data (state)
    mutations: {
        resetState(state, payload) {
            state._apiURL = 'https://ainakcloud.herokuapp.com';
            // state._apiURL = 'http://127.0.0.1:8000';
            state._token = '';
            state._user_authenticated = false;
            state._userID = '';
            state._username= '',
            state.loadedModels = [];
            state.userProfile = [];
            state.userParentProfile = [];
            state.userChildrenProfiles = [];
            state.licensesLeft = 0;
            state.modelInfo = [];
            state.modelMetaData = [];
            state.openUploadPage = 0;
            state.uploadProgress = [];
            state.uploadStatus = [];
            state.stopTutorial = false;
            state.stopTutorial = true;

            state.PaymentPortal_linked= false;
            state.PaymentPortal_CustomerObject= [];
            state.PaymentPortal_SubscriptionObject= [];
            state.PaymentPortal_PlanObject= [];
        },
        resetUploadProgress(state, payload) {
            state.openUploadPage= 0;
            state.uploadProgress=[];
            state.uploadStatus=[];
        },
        saveToken: (state, payload) => {
            state._token = payload;
            state._user_authenticated = true;
        },
        saveUserID: (state, payload) => {
            state._userID = payload;
        },
        saveUsername: (state, payload) => {
            state._username = payload;
        },
        saveAllModelsData: (state, payload) => {
            state.loadedModels=[];
            state.loadedModels = payload;
        },
        // openUploadPage: state => {
        //     state.openUploadPage = 1;
        // },
        trackUploadProgress: (state, payload) => {
            Vue.set(state.uploadProgress, payload.index, payload.progress)
        },
        updateUploadStatus: (state, payload) => {
            Vue.set(state.uploadStatus, payload.index, payload.status)
        },
        deleteModelFromLoadedModels: (state, payload) =>{
            state.loadedModels =  state.loadedModels.filter(n => n !== payload);
        },
        saveUserProfile:(state, payload) => {
            state.userProfile = [];
            state.userProfile = payload;
        },
        saveUserFirstLogin:(state, payload) => {
            state.isNewUser = payload;
        },
        saveLicensesLeft:(state, payload) => {
            state.licensesLeft = payload;
        },
        saveChildrenProfiles:(state, payload) => {
            state.userChildrenProfiles = payload;
        },
        saveParentProfile:(state, payload) => {
            state.userParentProfile = payload;
        },
        changeCurrentTabValue:(state, payload) => {
            state.openUploadPage = payload;
        },
        changeStopTutorial:(state) => {
            state.stopTutorial = true;
        },
        save_Reepay_customerObject:(state,payload) =>{
            state.PaymentPortal_CustomerObject = payload;
        },
        save_Reepay_subscriptionObject:(state,payload) =>{
            state.PaymentPortal_SubscriptionObject = payload;
        },
        save_Reepay_planObject:(state,payload) =>{
            state.PaymentPortal_PlanObject = payload;
            state.PaymentPortal_linked = true;
        },
    },
    // Actions = Functions that call the mutations that edit the data (state) (API calls to the server goes here)
    actions: {
        resetState(context, payload) {
            context.commit('resetState', payload);
        },

        resetUploadProgress(context, payload) {
            context.commit('resetUploadProgress', payload);
            context.dispatch('downloadAllUserModelsFromServer');
        },

        stopTutorial(context) {
            context.commit('changeStopTutorial');
        },

        userLogin: (context, payload) => {
            return new Promise((resolve, reject) => {
                context.dispatch('resetState', 'Login attempt started, Rest old session');

                axios.post(context.state._apiURL + '/login/', payload)
                    .then(response => {                      

                        context.commit('saveToken', response.data.token);

                        let diff = Math.abs( new Date(jwt_decode(response.data.token).exp * 1000) - new Date()) / 1000;
                        console.log('Token life span: ', Math.floor(diff / 60) % 60, 'minutes');

                        let webApiUrl = context.state._apiURL + '/api/profile/current/';
                        let tokenStr = context.state._token;

                        axios.get(webApiUrl, {headers: {'Authorization': `JWT ${tokenStr}`}})
                            .then(response => {
                                context.commit('saveUserID', response.data.id);
                                context.commit('saveUsername', response.data.username);




                                let webApiUrl = context.state._apiURL + '/api/profile/' + context.state._userID + '/';
                                let tokenStr = context.state._token;
                                axios.get(webApiUrl, {headers: {"Authorization": `JWT ${tokenStr}`}})
                                    .then(response => {
                                        console.log("PROFILE:::",response.data );
                                        context.commit('saveUserFirstLogin', response.data.first_login);


                                        context.dispatch('PaymentPortal_get_customer_list', payload)
                                        .then(() => { resolve();})
                                        .catch(error => {
                                            console.log("PaymentPortal get_customer_list error: ", error.data);
                                            reject();
                                        });

                                    })
                                    .catch(error => {
                                        console.log(error.data);
                                        reject();
                                    });






                            })
                            .catch(() => {
                                context.dispatch('resetState', 'Get current user profile ID failed');
                            });
                        resolve();
                    })
                    .catch(() => {
                        context.dispatch('resetState', 'Login Failed');
                        reject();
                    });
            })

        },

        /*
        1. Get Customer list - to get customer handle
        2. Get subscription list - use customer handle to get subscription handle
        */
        PaymentPortal_get_customer_list: (context) => {
            return new Promise((resolve, reject) => {
            // console.log(payload.plan);
            let key = 'priv_4c16257aef0c930769c5966fe89bbbfe:';
            let authtoken = btoa(key);
            axios.get('https://api.reepay.com/v1/customer',
            { 
                headers: {
                    "Authorization" : `Basic ${authtoken}`, 
                    "Content-Type" : 'application/json'
                }
            })
            .then(response => {
                // console.log("PaymentPortal List response: ", response);
                // console.log(response.data.content);
                
                for(let i =0; i <response.data.content.length; i++) {
                    // console.log(i + response.data.content[i].email + payload.username);
                    if( response.data.content[i].email == context.state._username){
                        
                        console.log("Customer handle: " + response.data.content[i].handle);
                        
                        context.commit('save_Reepay_customerObject', response.data.content[i]);
                        // console.log(context.state.PaymentPortal_CustomerObject);

                        context.dispatch('PaymentPortal_get_subscription_list', response.data.content[i].handle).then(() => {                   
                            // console.log("Subscription_list successful");
                            resolve();
                        })
                        .catch(error => {
                            console.log("Subscription_list Unsuccess error: ", error.data);
                            reject();
                        });
                        break;
                    }
                    else{
                        continue;
                    }
                }
                resolve();
            })
            .catch(error => {
                console.log("PaymentPortal List Unsuccess error: ", error.data);
                reject();
            });
            })
        },


        PaymentPortal_get_customer_object: (context,payload) => {
            return new Promise((resolve, reject) => {
            // console.log(payload.plan);
            let key = 'priv_4c16257aef0c930769c5966fe89bbbfe:';
            let authtoken = btoa(key);
            axios.get('https://api.reepay.com/v1/customer/'+payload,
            { 
                headers: {
                    "Authorization" : `Basic ${authtoken}`, 
                    "Content-Type" : 'application/json'
                }
            })
            .then(response => {
                console.log("PaymentPortal CustomerObject Success");
                console.log("PaymentPortal CustomerObject response: ", response);
                resolve();
            })
            .catch(error => {
                console.log("PaymentPortal CustomerObject Unsuccess");
                console.log("PaymentPortal CustomerObject error: ", error.data);
                reject();
            });
            })
        },
        
        PaymentPortal_get_subscription_list: (context,payload) => {
            return new Promise((resolve, reject) => {
            // console.log(payload.plan);
            let key = 'priv_4c16257aef0c930769c5966fe89bbbfe:';
            let authtoken = btoa(key);
            axios.get('https://api.reepay.com/v1/subscription',
            { 
                headers: {
                    "Authorization" : `Basic ${authtoken}`, 
                    "Content-Type" : 'application/json'
                }
            })
            .then(response => {
                console.log("PaymentPortal SubscriptionList Success response: ", response);
                // console.log(response.data.content);
                // console.log(payload);
                
                for(let i =0; i <response.data.content.length; i++) {
                    // console.log(i + response.data.content[i].email + payload.username);
                    if( response.data.content[i].customer == payload){
                        console.log("Subscription handle: " +response.data.content[i].handle);

                        console.log("Subscription Match response: ", response.data.content[i]);
                        context.commit('save_Reepay_subscriptionObject', response.data.content[i]);

                        // console.log("Subscription TrialEndDate: ", response.data.content[i].trial_end);
                        context.dispatch('gettrialdaysremaining'); 
                        
                        context.dispatch('PaymentPortal_get_plan_object', response.data.content[i].plan).then(() => {                  
                            // console.log("subscription_Object successful");
                            
                            resolve();
                        })
                        .catch(error => {
                            console.log("subscription_Object Unsuccess error: ", error.data);
                            reject();
                        });
                        break;
                    }
                    else{
                        continue;
                    }
                }
                resolve();
            })
            .catch(error => {
                console.log("PaymentPortal SubscriptionList Unsuccess error: ", error.data);
                reject();
            });
            })
        },
        
        PaymentPortal_get_subscription_object: (context,payload) => {
            return new Promise((resolve, reject) => {
            // console.log(payload.plan);
            let key = 'priv_4c16257aef0c930769c5966fe89bbbfe:';
            let authtoken = btoa(key);
            axios.get('https://api.reepay.com/v1/subscription/'+payload,
            { 
                headers: {
                    "Authorization" : `Basic ${authtoken}`, 
                    "Content-Type" : 'application/json'
                }
            })
            .then(response => {
                context.commit('save_Reepay_subscriptionObject', response.data);

                console.log("PaymentPortal subscription Success response: ", response);
                context.dispatch('PaymentPortal_get_subscription_list', response.data.content[i].handle).then(() => {                   
                    // console.log("Subscription_list successful");
                    resolve();
                })
                .catch(error => {
                    console.log("Subscription_list Unsuccess error: ", error.data);
                    reject();
                });
                resolve();
            })
            .catch(error => {
                console.log("PaymentPortal subscription Unsuccess error: ", error.data);
                reject();
            });
            })
        },

        
        PaymentPortal_get_plan_list: (context,payload) => {
            return new Promise((resolve, reject) => {
            // console.log(payload.plan);
            let key = 'priv_4c16257aef0c930769c5966fe89bbbfe:';
            let authtoken = btoa(key);
            axios.get('https://api.reepay.com/v1/subscription',
            { 
                headers: {
                    "Authorization" : `Basic ${authtoken}`, 
                    "Content-Type" : 'application/json'
                }
            })
            .then(response => {
                // console.log("PaymentPortal SubscriptionList Success response: ", response);
                // console.log(response.data.content);
                // console.log(payload);
                
                for(let i =0; i <response.data.content.length; i++) {
                    // console.log(i + response.data.content[i].email + payload.username);
                    if( response.data.content[i].customer == payload){
                        console.log("plan handle: " +response.data.content[i].handle);

                        // context.commit('save_Reepay_subscriptionObject', response.data.content[i]);
                        // console.log(context.state.PaymentPortal_SubscriptionObject);

                        context.dispatch('PaymentPortal_get_plan_object', response.data.content[i].handle).then(() => {                   
                            // console.log("subscription_Object successful");
                            resolve();
                        })
                        .catch(error => {
                            console.log("subscription_Object Unsuccess error: ", error.data);
                            reject();
                        });
                        break;
                    }
                    else{
                        continue;
                    }
                }
                resolve();
            })
            .catch(error => {
                console.log("PaymentPortal SubscriptionList Unsuccess error: ", error.data);
                reject();
            });
            })
        },
        
        PaymentPortal_get_plan_object: (context,payload) => {
            return new Promise((resolve, reject) => {
            // console.log(payload.plan);
            let key = 'priv_4c16257aef0c930769c5966fe89bbbfe:';
            let authtoken = btoa(key);
            axios.get('https://api.reepay.com/v1/plan/' + payload + '/current' ,
            { 
                headers: {
                    "Authorization" : `Basic ${authtoken}`, 
                    "Content-Type" : 'application/json'
                }
            })
            .then(response => {
                context.commit('save_Reepay_planObject', response.data);

                console.log("PaymentPortal plan Success response: ", response);
                console.log("plan object: ", context.state.PaymentPortal_PlanObject);
                resolve();
            })
            .catch(error => {
                console.log("PaymentPortal plan Unsuccess error: ", error.data);
                reject();
            });
            })
        },
        

        gettrialdaysremaining(context){
            if(this.state.PaymentPortal_SubscriptionObject.in_trial){
                let trailenddate = this.state.PaymentPortal_SubscriptionObject.trial_end;

                // console.log(this.state.PaymentPortal_SubscriptionObject.trial_end);
                let day = parseInt(trailenddate.split('T')[0].split('-')[2]);
                let month = parseInt(trailenddate.split('T')[0].split('-')[1]);
                let year = parseInt(trailenddate.split('T')[0].split('-')[0]);
                let enddate = new Date(year, month-1, day);
                var date = new Date();
                if(enddate.getTime() > date.getTime()){
                    var days = ((enddate.getTime() - date.getTime()) / 1000 / 3600 / 24);
                    console.log(parseInt(days) + ' Days Left');
                }
                else{
                    alert('Trial Period expired : 0 Day Remaining');
                }
            }
                
        },
        

        userRegistration: (context, payload) => {
            return new Promise((resolve, reject) => {
                let webApiUrl = context.state._apiURL + '/api/profile/u/';
                let tokenStr = context.state._token;
                axios.post(webApiUrl, payload, {headers: {"Authorization": `JWT ${tokenStr}`}})
                    .then(response => {
                        console.log("registration response: ", response);
                        resolve();
                    })
                    .catch(error => {
                        console.log("registration error: ", error.data);
                        reject();
                    });
            })

        },

        userRegistrationIndividual: (context, payload) => {
            return new Promise((resolve, reject) => {


            let  credential = {
                "username": "ainak_signup",
                "password": "z#534Lj%g=t'sTQ#"
            };

                axios.post(context.state._apiURL + '/login/', credential)
                    .then(response => {
                        // context.commit('saveUserProfile', response.data);
                        console.log("Login response: ", response);

                        let webApiUrl = context.state._apiURL + '/api/profile/u/';
                        let tokenStr = response.data.token;
                        axios.post(webApiUrl, payload ,{ headers: {"Authorization" : `JWT ${tokenStr}`} })
                            .then(response => {
                                console.log("registration response: ", response);
                                let credential = {
                                    "username": payload.username,
                                    "password": payload.password
                                };
                                context.dispatch('userLogin', credential).then(() => {
                                    resolve();
                                })
                                .catch(() => {
                                    reject();
                                });
                            })
                            .catch(error => {
                                console.log("registration error: ", error.data);
                                reject();
                            });


                    })
                    .catch(error => {
                        console.log("registration error: ", error.data);
                    });




            })

        },


        userRegistrationIndividual_with_Payment: (context, payload) => {
            return new Promise((resolve, reject) => {

            let  credential = {
                "username": "ainak_signup",
                "password": "z#534Lj%g=t'sTQ#"
            };

                axios.post(context.state._apiURL + '/login/', credential)
                    .then(response => {
                        // context.commit('saveUserProfile', response.data);
                        console.log("Login response: ", response);

                        let webApiUrl = context.state._apiURL + '/api/profile/u/';
                        let tokenStr = response.data.token;

                        // payload.email = payload.username;
                        console.log(payload);
                        
                        axios.post(webApiUrl, payload ,{ headers: {"Authorization" : `JWT ${tokenStr}`} })
                            .then(response => {
                                console.log("Backend Success");
                                console.log("registration response: ", response);

                                // add axios post for PaymentPortalApi

                                context.dispatch('PaymentPortal_create_customer_wt_subscription', payload).then(() => {  
                                    console.log("PaymentPortal Success; Backend success");

                                    context.dispatch('userLogin', payload).then(() => {                   
                                        console.log("Signin Success; PaymentPortal Success; Backend success");
                                        resolve();
                                    })
                                    .catch(error => {                                          
                                        console.log("Signin Unsuccess; PaymentPortal Success; Backend success");
                                        console.log("Signin error: ", error.data);
                                        reject();
                                    });
                                })
                                .catch(error => {                                          
                                    console.log("PaymentPortal Unsuccess; Backend success");
                                    console.log("Signin error: ", error.data);
                                    reject();
                                });
                            })
                            .catch(error => {
                                console.log("Backend unsuccess");
                                console.log("registration error: ", error.data);
                                reject();
                            });
                    })
                    .catch(error => {
                        console.log("admin error: ", error.data);
                    });
            })
        },


        
        PaymentPortal_create_only_customer: (context, payload) => {
            return new Promise((resolve, reject) => {
                
            let key = 'priv_4c16257aef0c930769c5966fe89bbbfe:';
            let authtoken = btoa(key);
            axios.post('https://api.reepay.com/v1/customer', payload,
            { 
                headers: {"Authorization" : `Basic ${authtoken}`, "Accept" : `application/json` , "Content-Type" : 'application/json'} ,
                data : {"email": payload.email,
                        "test": true,
                        "first_name": payload.username,
                        "generate_handle": true}
            })
            .then(response => {
                console.log("PaymentPortal Success; Backend success");
                console.log("PaymentPortal response: ", response);
                console.log(response.data.handle);
                // let Reepay_customer_handle = response.data.handle;
                // let Reepay_plan_handle = "plan-e7a0e";
                resolve();
            })
            .catch(error => {
                console.log("PaymentPortal Unsuccess; Backend Success");
                console.log("PaymentPortal error: ", error.data);
                reject();
            });
            })
        },

        PaymentPortal_create_customer_wt_subscription: (context,payload) => {
            return new Promise((resolve, reject) => {
            // console.log(payload.plan);
            let key = 'priv_4c16257aef0c930769c5966fe89bbbfe:';
            let authtoken = btoa(key);
            axios.post('https://api.reepay.com/v1/subscription', payload,
            { 
                headers: {"Authorization" : `Basic ${authtoken}`, "Accept" : `application/json` , "Content-Type" : 'application/json'} ,
                data : {
                        "plan": payload.plan,
                        "create_customer": 
                        { 
                            "email": payload.email,
                            "handle": payload.username,
                            "first_name": payload.first_name,
                            "last_name": payload.last_name,
                            "generate_handle": true 
                        },
                        // "no_trial": true,
                        "generate_handle": true,
                        "signup_method": "email"
                    }
            })
            .then(response => {
                console.log("PaymentPortal Success; Backend success");
                console.log("PaymentPortal response: ", response);
                console.log(response.data.handle);
                let Reepay_customer_handle = response.data.handle;
                console.log(Reepay_customer_handle);
                resolve();
            })
            .catch(error => {
                console.log("PaymentPortal Unsuccess; Backend Success");
                console.log("PaymentPortal error: ", error.data);
                reject();
            });
            })
        },

        PaymentPortal_create_subscription_to_existing_customer: (context, payload) => {
            return new Promise((resolve, reject) => {
                
            let key = 'priv_4c16257aef0c930769c5966fe89bbbfe:';
            let authtoken = btoa(key);
            let Reepay_plan_handle = "plan-e7a0e";
            axios.post('https://api.reepay.com/v1/subscription', payload,
            { 
                headers: {"Authorization" : `Basic ${authtoken}`, "Accept" : `application/json` , "Content-Type" : 'application/json'} ,
                data : {"customer": "cust-0016",
                        "plan": Reepay_plan_handle,
                        "generate_handle": true,
                        "signup_method": "email"
                    }
            })
            .then(response => {
                console.log("PaymentPortal Success; Backend success");
                console.log("PaymentPortal response: ", response);
                console.log(response.data.handle);
                let Reepay_customer_handle = response.data.handle;
                let Reepay_plan_handle = "plan-e7a0e";
                resolve();
            })
            .catch(error => {
                console.log("PaymentPortal Unsuccess; Backend Success");
                console.log("PaymentPortal error: ", error.data);
                reject();
            });
            })
        },



        


        downloadAllUserModelsFromServer: (context) => {
            return new Promise((resolve, reject) => {

                let meta = [];
                let models= [];

                let webApiUrl = context.state._apiURL + '/api/models/';
                let tokenStr = context.state._token;
                axios.get(webApiUrl, {headers: {"Authorization": `JWT ${tokenStr}`}})
                    .then(({data}) => {
                        models = data;
                        console.log(data);

                        for(let i =0; i <data.length; i++) {
                            let webApiUrl = context.state._apiURL + '/api/meta/' + data[i].id + '/';
                            let tokenStr = context.state._token;
                            axios.get(webApiUrl, {headers: {"Authorization": `JWT ${tokenStr}`}})
                                .then(({data}) => {
                                    meta[i] = data;
                                    Object.assign(models[i], {meta: data});
                                    // Object.assign(models[i], {model_numb:i+1});
                                })
                                .catch(() => {
                                    meta[i] = [];
                                    Object.assign(models[i], {meta: {}});
                                    // Object.assign(models[i], {model_numb:i+1});
                                });
                        }
                        context.commit('saveAllModelsData', models);
                        console.log(models);
                        resolve();
                    })
                    .catch(() => {
                        context.commit('saveAllModelsData', []);
                        reject();
                    });
            })
        },

        uploadModelsToServer: (context, payload) => {
            return new Promise((resolve, reject) => {

                let webApiUrl = context.state._apiURL + '/api/models/';
                let tokenStr = context.state._token;
                context.commit('updateUploadStatus', {index: payload.index, status: 'uploading'});

                axios.post(webApiUrl, payload.data,
                    {
                        headers: {"Authorization": `JWT ${tokenStr}`},
                        onUploadProgress: function (progressEvent) {
                            context.commit('trackUploadProgress', {
                                index: payload.index,
                                progress: Math.round((progressEvent.loaded * 100) / progressEvent.total)
                            });
                        }
                    })
                    .then((res) => {
                        context.commit('updateUploadStatus', {index: payload.index, status: 'uploaded'});





                        let webApiUrl = context.state._apiURL + '/api/meta/'+  res.data.id +'/';
                        let tokenStr = context.state._token;
                        axios.put(webApiUrl, payload.meta,{headers: {"Authorization": `JWT ${tokenStr}`}})
                            .then((res) => {
                                console.log("Okiee accepted!! ", payload.index, res, payload.meta);

                                //reload all models for home page
                                context.dispatch('downloadAllUserModelsFromServer')
                                .then(() => {
                                    console.log("success - model loaded")
                                })
                                .catch(() => {
                                    console.log("failed- model not loaded")
                                })
                                resolve();
                            })
                            .catch(() => {
                                reject();
                            });

                    })
                    .catch(() => {
                        context.commit('updateUploadStatus', {index: payload.index, status: 'failed'});
                        console.log("rejected!! ", payload.index);
                        resolve(payload.index);
                    });
            })
        },

        deleteModelsFromServer: (context, payload) => {
            return new Promise((resolve, reject) => {

                let webApiUrl = context.state._apiURL + '/api/models/' + payload.id;
                let tokenStr = context.state._token;

                axios.delete(webApiUrl, {headers: {"Authorization": `JWT ${tokenStr}`}})
                    .then(() => {
                        context.commit('deleteModelFromLoadedModels', payload);
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    });
            })
        },

        getUserProfile: (context) => {

            return new Promise((resolve, reject) => {

                console.log(context.state._userID , "~~~~");
                let webApiUrl = context.state._apiURL + '/api/profile/' + context.state._userID + '/';
                let tokenStr = context.state._token;
                axios.get(webApiUrl, {headers: {"Authorization": `JWT ${tokenStr}`}})
                    .then(response => {

                        console.log("PROFILE:::",response.data );

                        context.commit('saveUserProfile', response.data);

                        let webApiUrl = context.state._apiURL + '/api/profile/' + response.data.parent_id + '/';
                        axios.get(webApiUrl, {headers: {"Authorization": `JWT ${tokenStr}`}})
                            .then(response => {
                                context.commit('saveParentProfile', response.data);
                            })
                            .catch(error => {
                                reject();
                                console.log(error.data)
                            });

                        let max_available_child = response.data.max_children;

                        if (response.data.max_children === 0) {
                            context.commit('saveLicensesLeft', 0);
                        } else {
                            webApiUrl = context.state._apiURL + '/api/profile/children/';
                            axios.get(webApiUrl, {headers: {"Authorization": `JWT ${tokenStr}`}})
                                .then(({data}) => {

                                    context.commit('saveLicensesLeft', max_available_child - data.length);
                                    context.commit('saveChildrenProfiles', data);
                                })
                                .catch(error => {
                                    reject();
                                    console.log(error.data)
                                });
                        }
                        resolve();

                    })
                    .catch(error => {
                        console.log(error.data);
                        reject();
                    });
            })

        },

        updateUserProfile: (context, payload) => {
            let webApiUrl = context.state._apiURL + '/api/profile/' + context.state._userID + '/';
            let tokenStr = context.state._token;
            axios.put(webApiUrl, payload ,{ headers: {"Authorization" : `JWT ${tokenStr}`} })
                .then(response => {
                    context.commit('saveUserProfile', response.data);
                })
                .catch(error => {
                    console.log(error.data)
                });
        },

        updateFirstLogin: (context, payload) => {
            let webApiUrl = context.state._apiURL + '/api/profile/' + context.state._userID + '/';
            let tokenStr = context.state._token;
            axios.put(webApiUrl, payload ,{ headers: {"Authorization" : `JWT ${tokenStr}`} })
                .then(response => {
                    console.log(response.data);
                    context.commit('saveUserFirstLogin', false);
                })
                .catch(error => {
                    console.log(error.data)
                });
        },

        updateAppAccess: (context, payload) => {

            let webApiUrl = context.state._apiURL + '/api/models/onApp/' + payload.id + '/';
            let tokenStr = context.state._token;
            axios.put(webApiUrl, {'app_access': payload.app_access} ,{ headers: {"Authorization" : `JWT ${tokenStr}`} })
                .then(response => {
                    console.log('success',response.data);
                    // context.commit('saveUserProfile', response.data);
                })
                .catch(error => {
                    console.log('error', error.data)
                });
        },

        updateFailedModelStatus: (context, payload) => {
            context.commit('changeCurrentTabValue', 1);
            for (let i = 0; i < payload; i++) {
                context.commit('updateUploadStatus', {index: i, status: 'failed'});
            }
        },

        setCurrentTab: (context, payload) => {
            context.commit('changeCurrentTabValue', payload)
        },
    },
    //Getter = Get the state data (computed/filtered/processed data from the state)
    getters: {
        getAllUserModels: state => {
            return state.loadedModels;
        },
        getShowTut: state => {
            return state.isNewUser;
        },
        getUploadPage: state => {
            return state.openUploadPage;
        },
        getUploadProgress: state => payload => {
            return state.uploadProgress[payload];
        },
        getUploadStatus: state => payload => {
            return state.uploadStatus[payload];
        },
        getTotalModels: state => {
            return state.loadedModels.length;
        },
        getStopTutorial: state => {
            return state.stopTutorial;
        }
    },
    //plugins =  ???? (used to store data in vuex-persistent data
    plugins: [createPersistedState({
        // paths: ['_token', '_user_authenticated', '_userID', 'loadedModels']
        paths: []
    })]
});
